import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { IChatInteractionResponseTable } from '@common/models/Chat/IChatResponse';
import { ChatResponseTableColumn } from '@common/types/ChatResponseTableColumn';

@Component({
  selector: 'app-chat-response-tables',
  templateUrl: './chat-response-tables.component.html',
  styleUrl: './chat-response-tables.component.scss'
})
export class ChatResponseTablesComponent implements OnChanges {

  @Input() chatTable: IChatInteractionResponseTable;

  tableColumns: ChatResponseTableColumn[] = [];
  tableRows: any[] = [];
  globalFilterFields: string[] = [];

  ngOnChanges(changes: SimpleChanges) {
    if (changes.chatTable && this.chatTable) {
      this.parseTableData();
    }
  }

  private parseTableData(): void {
    if (!this.chatTable?.headers || !Array.isArray(this.chatTable.rows)) {
      this.tableColumns = [];
      this.tableRows = [];
      return;
    }

    // Use header as both field and header (if headers are unique and valid)
    this.tableColumns = this.chatTable.headers.map(header => ({
      field: header,
      header: header,
      sortField: `${header}__raw`
    }));
    // Set global filter fields
    this.globalFilterFields = this.chatTable.headers;
    // Convert string[][] to array of objects, key as header
    this.tableRows = this.chatTable.rows.map(rowArr => {
      const rowObj: any = {};
      this.chatTable.headers.forEach((header, i) => {
        rowObj[header] = rowArr[i];
        rowObj[`${header}__raw`] = this.getComparableValue(rowArr[i]);
      });
      return rowObj;
    });
  }

  private getComparableValue(value: unknown): number | string | null {
    switch (true) {
      case value === null || value === undefined:
        return null;
      case typeof value === 'number':
        return value;
      case value instanceof Date:
        return (value).getTime();
      case typeof value === 'string': {
        const numericValue = this.tryParseNumber(value);
        if (numericValue !== null) {
          return numericValue;
        }

        const dateValue = this.tryParseDate(value);
        if (dateValue !== null) {
          return dateValue;
        }

        return value.toLowerCase();
      }
      default:
        return String(value);
    }
  }

  private tryParseNumber(rawValue: string): number | null {
    const sanitized = rawValue.replaceAll(',', '').replaceAll(/[%$€£\s]/g, '');

    if (sanitized === '' || Number.isNaN(Number(sanitized))) {
      return null;
    }

    return Number(sanitized);
  }

  private tryParseDate(rawValue: string): number | null {
    const cleanedValue = rawValue
      .replaceAll(/\sat\s/gi, ' ')
      .replaceAll(/\sUTC$/gi, ' UTC')
      .replaceAll(/(\d)(st|nd|rd|th)/gi, '$1')
      .trim();

    const parsed = Date.parse(cleanedValue);

    return Number.isNaN(parsed) ? null : parsed;
  }
}
